<template>
  <div class="animated fadeIn targetcollectionform">
    <b-card>
      <div slot="header">
        Billing Commitment - Form
      </div>
      <b-row class="justify-content-center">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>Cust. Code</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="cust_info"
              @keyup.13.native="lkuKoranCustShow=true"
              :state="!$v.model.customer_id.$error"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuKoranCustShow=true" variant="primary">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Sales Ex.</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="sales_info"
              @keyup.13.native="lkuSalesShow=true"
              :state="!$v.model.salesae_id.$error"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuSalesShow=true" variant="primary">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Description</label>
            </b-input-group-prepend>
            <b-form-textarea
              id="textarea"
              v-model="model.uraian"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-input-group>
          <b-row>
              <b-col lg="4">
                  <b-input-group>
                    <b-input-group-prepend>
                      <label>Sales Period/Year</label>
                    </b-input-group-prepend>
                    <b-form-input v-model="model.tahun" :state="!$v.model.tahun.$error" type="number"></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="8">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Billing Commitment</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                  </b-input-group-prepend>
                  <my-number class="form-control text-right"
                    separator=","
                    v-model="model.budget"
                    :precision="2"
                    :state="!$v.model.budget.$error"
                  ></my-number>
                </b-input-group>
              </b-col>
          </b-row>
          <b-row no-gutters>
              <b-col cols="5">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Cash Back</label>
                  </b-input-group-prepend>
                  <b-form-input v-model="model.cashbackpc" type="number" :state="!$v.model.cashbackpc.$error"></b-form-input>
                </b-input-group>
              </b-col>
              <b-col cols="7">
                <b-input-group>
                  <b-input-group-append>
                    <span class="p-2">
                      <i class="fa fa-percent"></i>
                    </span>
                  </b-input-group-append>
                  <b-input-group-append>
                    <span class="p-2"> (if Billing commitment achieved)</span>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
          </b-row>
            <label>Attachment  <span class="p-2" v-if="(model.attchFileNm)"><b-link @click="attachmentDownload(model)"><i class="fa fa-paperclip"></i> {{ model.attchFileNm }}</b-link></span>   </label>

              <b-form-file class="ml-2"
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>


        </b-col>
        <b-col lg="6">
          <h4 class="mt-1">Progress Sales</h4>
          <b-row>
              <b-col lg="10" xl="8">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Booked Order</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                  </b-input-group-prepend>
                  <my-number
                    separator=","
                    v-model="model.ordered"
                    :precision="2"
                    disabled
                    class="form-control text-right"
                  ></my-number>
                </b-input-group>
                <!-- <b-input-group>
                  <b-input-group-prepend>
                    <label>Delivered Sales</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                  </b-input-group-prepend>
                  <my-number
                    separator=","
                    v-model="model.delivered"
                    :precision="2"
                    disabled
                    class="form-control text-right"
                  ></my-number>
                </b-input-group> -->
              </b-col>
          </b-row>
          <hr />
          <b-row>
              <b-col lg="10" xl="8">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Compliment</label>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                </b-input-group-prepend>
                <my-number
                  separator=","
                  v-model="model.compliment"
                  :precision="2"
                  disabled
                  class="form-control text-right"
                ></my-number>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend>
                  <label>Discount</label>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                </b-input-group-prepend>
                <my-number
                  separator=","
                  v-model="model.discount"
                  :precision="2"
                  disabled
                  class="form-control text-right"
                ></my-number>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend>
                  <label>Saving Value</label>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                </b-input-group-prepend>
                <my-number
                  separator=","
                  v-model="model.saving"
                  :precision="2"
                  disabled
                  class="form-control text-right"
                ></my-number>
              </b-input-group>
              </b-col>
          </b-row>
          <hr />
          <b-row>
              <b-col lg="10" xl="8">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>TDP Claim Acccum.</label>
                  </b-input-group-prepend>
                  <b-input-group-prepend>
                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                  </b-input-group-prepend>
                  <my-number
                    separator=","
                    v-model="model.cashbackpaid"
                    :precision="2"
                    disabled
                    class="form-control text-right"
                  ></my-number>
                </b-input-group>
              </b-col>
          </b-row>

        </b-col>
      </b-row>
      <hr />
      <b-input-group class="justify-content-center mt-1">
        <b-button class="btn btn-success mr-1" @click.stop="save()">Save</b-button>
        <b-button class="btn btn-warning ml-1" @click.stop="cancel()">Cancel</b-button>
      </b-input-group>
    </b-card>

    <b-modal
      v-model="lkuKoranCustShow"
      size="lg"
      :hide-footer="true"
      title="List of Customer"
      :centered="true"
    >
      <lku-koran-cust @click="onSelectKoranCust"></lku-koran-cust>
    </b-modal>
    <b-modal
      v-model="lkuSalesShow"
      size="lg"
      :hide-footer="true"
      title="List of Customer"
      :centered="true"
    >
      <lku-salesae @click="onSelectsales"></lku-salesae>
    </b-modal>
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import billcom from "../../apis/salesbillcom";

import { validationMixin } from "vuelidate";
import {
  required,
  decimal,
} from "vuelidate/lib/validators";

import lkuKoranCust from "../lookup/lkuCustomer";
import lkuSalesae from "../lookup/lkuSalesae";

toastr.init();

export default {
  components: { lkuKoranCust, lkuSalesae, myNumber },
  mixins: [validationMixin],
  validations: {
    model: {
      customer_id: { required },
      salesae_id: { required },
      tahun: { required },
      cashbackpc: { required },
      budget: { required } // budget commitmnent
    }
  },
  data() {
    return {
      saveEnabled: true,
      lkuKoranCustShow: false,
      lkuSalesShow: false,
      lkuSalesitemShow: false,
      showDelConfirm: false,
      file:null,
      model: {
        customer_id: null,
        customer_name: null,
        tahun:moment(this.$store.state.user.tglaktif).format("YYYY"),
        salesae_id: null,
        salesae_name: null,
        startdate: null,
        finishdate: null,
        budget: 0,
        cashbackpc: 0,
        cashbackval: 0,
        cashbackpaid:0,
        delivered: 0,
        ordered: 0,
        compliment: 0,
        saving: 0,
        uraian: null,
        matauang: this.$store.state.user.matauang
      },
      uanguser: this.$store.state.user.matauang,
      currency: [{ value: "IDR", text: "IDR" }],

      cust_info: null,
      sales_info: null
    };
  },
  async created() {
    if (this.$route.params.billcomkey) {
      const [header] = await billcom.detail(this.$route.params);
      this.model = header;
      this.model.startdate = moment(header.startdate).format("YYYY-MM-DD");
      this.model.finishdate = moment(header.finishdate).format("YYYY-MM-DD");
      this.cust_info = `${header.customer_code} | ${header.customer_name}`;
      this.sales_info = `${header.salesae_name}`;
      // lines.map((item, idx) => {
      //   lines[idx].amount = item.budget;
      // });
      // this.packageLine.items = lines;
      this.calculating();
    } else {
      this.model.startdate=moment().startOf('month').format('YYYY-MM-DD')
      this.model.finishdate=moment().endOf('year').format('YYYY-MM-DD')
    }
    
  },

  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  watch: {
    "model.cashbackpc": function (newval) {
      this.calculating();
    },
    "model.budget": function (newval) {
      this.calculating();
    }
  },
  methods: {
    onSelectKoranCust(_selected) {
      this.cust_info = `${_selected.CustCode + " | " + _selected.CustName}`;
      this.model.customer_id = _selected.customer_id;
      this.model.customer_code = _selected.CustCode;
      this.model.customer_name = _selected.npwp_name || _selected.CustName;
      this.model.brand = _selected.CustName;
      this.lkuKoranCustShow = false;
    },
    onSelectsales(_selected) {
      this.sales_info = `${_selected.crewnik + " | " + _selected.salesae_name}`;
      this.model.salesae_id = _selected.salesae_id;
      this.model.salesae_name = _selected.salesae_name;
      this.lkuSalesShow = false;
    },

    calculating() {
      const cashbackpc = this.model.cashbackpc;
      const budget = this.model.budget;
      // const delivered = this.model.delivered;
      // const ordered = this.model.ordered;
      // const compliment = this.model.compliment;
      // const saving = this.model.saving;
      // const discount = this.model.discount;
      const cashbackval = budget * (parseInt(cashbackpc,10)/100);
      this.model.cashbackval = cashbackval;
    },
    attachmentDownload : async function(fl) {
        this.isLoading=true;
        try {
            await billcom.attachmentDownload(fl);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
        }
    },       

    async save() {
      if (this.invalidModel) {
        console.log("validation model : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          const row = new FormData();
          if (this.file){
            row.append('file', this.file);
            row.append('filename', this.file.name);
          }
          for (var key in this.model) {
              row.append(key, this.model[key]);
          }
          console.log('tahun: ', this.model.tahun);
          console.log('akhir tahun: ', new Date(this.model.tahun, 11, 31));

          row.set('startdate', moment(new Date(this.model.tahun, 0, 1)).format('YYYY-MM-DD'));
          row.set('finishdate', moment(new Date(this.model.tahun, 11, 31)).format('YYYY-MM-DD'));
          await billcom.save(row);
          toastr.success("Save successfully");
          router.push({ name: "sales.billingcommit" });
        } catch (error) {
          toastr.error(error, "ERROR MESSAGE");
        }
      }
    },
    cancel() {
      if (this.$store.state.prevRoute.name) {
        router.push({ name: this.$store.state.prevRoute.name });
      } else {
        router.push({ name: "sales.billingcommit" });
      }
    }
  }
};
</script>